export default "__VITE_ASSET__c28989b6__"